// import pirates from "./pirates/index.js"
import ember from "./ember/index.js"

// import starcross from "./starcross/index.js"
import school from "./school/index.jsx"
// import book from "./book/index.js"
// import heist from "./heist/index.js"

const games = {
    // pirates,
    ember,

    // starcross,
    school,
    // book,
    // heist,
}

export default games
